import Logger from 'utils/logger';

export const BrowserStorage = {
  set(key: string, value: string) {
    try {
      window.localStorage.setItem(key, value);
    } catch (e) {
      Logger.error(e);
    }
  },
  get(key: string): string | null {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      Logger.error(e);
    }
    return null;
  },
  remove(key: string) {
    try {
      return window.localStorage.removeItem(key);
    } catch (e) {
      Logger.error(e);
    }
  },
  logoutClear() {
    BrowserStorage.remove(BrowserStorage.keys.AuthToken);
    BrowserStorage.remove(BrowserStorage.keys.Stores.UnsavedValues);
    BrowserStorage.remove(BrowserStorage.keys.SocialLoginPageType);
    BrowserStorage.remove(BrowserStorage.keys.Cognito.IdToken);
    BrowserStorage.remove(BrowserStorage.keys.Cognito.AccessToken);
    BrowserStorage.remove(BrowserStorage.keys.Cognito.RefreshToken);
    BrowserStorage.remove(BrowserStorage.keys.Cognito.SelectedAccount);
    sessionStorage.removeItem(
      BrowserStorage.keys.Banners.DisconnectedProfilesDismissed,
    );
    sessionStorage.removeItem(
      BrowserStorage.keys.Banners.CalendarDisconnectedProfilesDismissed,
    );
    sessionStorage.removeItem(
      BrowserStorage.keys.Invitations.PendingModalDismissed,
    );
  },
  keys: {
    PaymentInfoBannerStatus: 'info-banner-last-payment-status',
    ExpiredReloadDate: 'expiredReloaded',
    Cognito: {
      IdToken: 'cognito-id-token',
      AccessToken: 'cognito-access-token',
      RefreshToken: 'cognito-refresh-token',
      SelectedAccount: 'cognito-selected-account',
    },
    Insights: {
      InsightsFilters: 'insights-filters',
      InsightsGraphsConfig: 'insights-graphs-config',
      InsightsPageFansActiveTab: 'insights-page-fans-active-tab',
      InsightsPagePostReachActiveTab:
        'insights-page-post-cumulative-reach-active-tab',
    },
    AuthToken: 'auth-token',
    PostsGridPreviewVariant: 'posts-grid-preview-variant',
    Stores: {
      AppLayout: 'app.layout',
      UnsavedValues: 'app.unsaved-values',
      PostsLayout: 'posts.layout',
      OptionsSelect: 'options-select',
      UsersListLayout: 'users-list.layout',
    },
    Posts: {
      PreviewVariant: 'posts.post-preview-variant',
    },
    InsightsLite: {
      InvitationDismissedAt: 'insights-lite-invitation-dismissed-at',
    },
    Dashboard: {
      TutorialsWidget: 'dashboard-tutorials-widget',
      DismissedFailedPosts: 'dashboard-dismissed-failed-posts',
    },
    OnboardingChecklist: {
      SentForApproval: 'onboarding-checklist-sent-for-approval',
      CompletionTracking: 'onboarding-checklist-completion-tracking',
    },
    Onboarding: {
      WelcomeVariant: 'onboarding-welcome-variant',
      Finished: 'onboarding-finished',
    },
    SocialLoginPageType: 'social-login-page-type',
    ConnectTracking: {
      Attempt: 'connect-tracking-attempt',
      AttemptCounts: 'connect-tracking-attempt-counts',
    },
    Banners: {
      DisconnectedProfilesDismissed: 'disconnected-profiles-banner-dismissed',
      CalendarDisconnectedProfilesDismissed:
        'calendar-disconnected-profiles-banner-dismissed',
    },
    Invitations: {
      PendingModalDismissed: 'pending-invitation-modal-dismissed',
    },
    Analytics: {
      LastUsedProfiles: 'analytics-last-used-profiles',
    },
    Language: 'app-language',
    SpeechLanguage: 'speech-language',
    Translation: {
      RecentLanguages: 'recent-translation-languages',
    },
  },
};
